// extracted by mini-css-extract-plugin
export default {"rowClickable":"styles_rowClickable__V-8ck"};